// Direktiva na renderovanie KURZOVEJ PONUKY VIRTUALNYCH HIER (prva uroven so skrytimi urovnami)
directives.virtualSportsbookDirective.sportsBookVG = function() {
    var directive = {
        "#sportVG": {
            "Sport<-": {
                ".@id": "#{Sport.Typ}#{Sport.ID}",
                ".@class+": function () {
                    if (this.ID) {
                        return " SB-level-root sport-border-color-" + this.ID;
                    }
                },
                ".@order": "Sport.Order",
                ".vg-image@src": function() {
                    if (this.ID) {
                        return "/stylesheets/images/vg/flat-virtual-sport-" + this.ID + ".jpg";
                    }
                },
                ".vg-sport-title": function () {
                    if (this.Name) {
                        return this.Name;
                    }
                },
                ".sport-icon@class+": function () {
                    if (this.ID) {
                        return " sport-icon-" + offer.vgID + "-region-" + this.ID;
                    }
                },
                ".vg-providers": {
                    "provider<-Sport.providers": {
                        ".@ID": function () {
                            if (this.Name) {
                                return this.Name;
                            }
                        },
                        "@vg-region": function (a) {
                            if (a.Sport.item.RegionID) {
                                return a.Sport.item.RegionID;
                            }
                        },
                        ".provider-name": function () {
                            if (this.leagues && this.Name && texts["ProviderName" + this.Name]) {
                                return "<span class='flag_" + this.Name + " size33'></span><span class='provider-name-label'>" + texts["ProviderName" + this.Name] + "</span><span class='icon-arrow-down'></span>";
                            }
                        },
                        ".provider-content": {
                            "l<-provider.leagues": {
                                ".@ID": function () {
                                    if (this.ID) {
                                        return "LC" + this.ID;
                                    }
                                },
                                ".league-name": function () {
                                    if (this.Name) {
                                        return this.Name;
                                    }
                                },
                                "@onmousedown": function (a) {
                                    if (a.Sport.item.ID && a.l.item.ID && this.Provider) {
                                        return "virtual.virtualLeagues(" + a.Sport.item.ID +  ", " + a.l.item.ID + ", '" + this.Provider + "')";
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        "@class+": function() {
            return "sportsBookVG--provider";
        }
    }
    T.sportsBookVG = $p("#sportsBookVG").compile(directive);
};

// Direktiva na renderovanie KURZOVEJ PONUKY VIRTUALNYCH HIER (prva uroven so skrytimi urovnami)
directives.virtualSportsbookDirective.sportsBookVGNoProviders = function() {
    var directive = {
        "#sportVG": {
            "Sport<-": {
                ".@id": "#{Sport.Typ}#{Sport.ID}",
                ".@class+": function (a) {
                    if (this.ID) {
                        return " SB-level-root sport-border-color-" + this.ID;
                    }
                },
                ".@order": "Sport.Order",
                ".virtual-sport__button-image@src": function() {
                    if (this.ID) {
                        return "/stylesheets/images/vg/flat-virtual-sport-" + this.ID + ".jpg";
                    }
                },
                ".virtual-sport__button-title": function () {
                    if (this.Name) {
                        return this.Name;
                    }
                },
                ".virtual-sport__button-icon@class+": function () {
                    if (this.ID) {
                        return " sport-icon-" + offer.vgID + "-region-" + this.ID;
                    }
                },
                "@onclick": function (a) {
                    if (this.ID) {
                        return "virtual.virtualLeaguesExpand(" + this.ID + ")";
                    }
                },
                ".virtual-sport__league-button": {
                    "league<-Sport.leagues": {
                        ".@ID": function (a) {
                            if (this.ID) {
                                return "LC" + this.ID;
                            }
                        },
                        "@vg-region": function (a) {
                            if (a.Sport.item.ID) {
                                return a.Sport.item.ID;
                            }
                        },
                        ".virtual-sport__league-header": function (a) {
                            if (this.Name) {
                                return "<span class='virtual-sport__league-icon flag_" + a.item.Provider + " size33'></span><span class='virtual-sport__league-name'>" + this.Name + "</span>";
                            }
                        },
                        "@onmousedown": function (a) {
                            if (a.Sport.item.ID && a.item.ID && a.item.Provider) {
                                return "virtual.virtualLeagues(" + a.Sport.item.ID +  ", " + a.item.ID + ", '" + a.item.Provider + "')";
                            }
                        }
                    }
                }
            }
        },
        "@class+": function() {
            return "sportsBookVG--vg-no-providers";
        }
    }
    T.sportsBookVGNoProviders = $p("#sportsBookVG").compile(directive);
}
